import TypeOfInstalationGarage from './TypeOfInstalationGarage';

export default TypeOfInstalationGarage;